/**
 * Real guest reviews from Google & Tripadvisor.
 * `source`: "google" | "tripadvisor" | "booking" | "airbnb"
 * `score`: number out of 5 (Google/Tripadvisor/Airbnb) or out of 10 (Booking)
 * `lang`: original language of the review (informational only)
 */
export const REVIEWS = [
  {
    id: "g1",
    source: "google",
    score: 5,
    author: "Giuseppe Cherchi",
    country: "Italia",
    date: "2025-11",
    lang: "it",
    text_it: "Ringrazio Valeria per l'ottima ospitalità e per la sua impeccabile gentilezza. La suite è più un appartamento che una camera, calda d'animo e di spirito. Ho dormito benissimo, una suite paradisiaca. Per chi cerca un'amica oltre che una proprietaria: il concetto di accoglienza centrato in pieno.",
    text_en: "I thank Valeria for her outstanding hospitality and impeccable kindness. The suite feels more like an apartment than a room — warm in soul and in spirit. I slept wonderfully, a true paradise of a suite. For anyone seeking a friend rather than just a host: the very meaning of hospitality.",
    text_fr: "Je remercie Valeria pour son hospitalité exceptionnelle et sa gentillesse irréprochable. La suite est plus un appartement qu'une chambre, chaleureuse de cœur et d'esprit. J'ai très bien dormi, une suite paradisiaque. Pour qui cherche une amie plutôt qu'une simple hôte : le sens même de l'accueil."
  },
  {
    id: "t1",
    source: "tripadvisor",
    score: 5,
    author: "530gracem",
    country: "Italia",
    date: "2025-10",
    lang: "it",
    text_it: "Ho soggiornato al B&B I Maestri di Napoli e l'esperienza è stata semplicemente eccellente. Fin dal primo momento si percepisce un'accoglienza autentica, calorosa e professionale.",
    text_en: "I stayed at B&B I Maestri in Naples and the experience was simply excellent. From the very first moment you can feel a welcome that is authentic, warm and professional.",
    text_fr: "J'ai séjourné au B&B I Maestri de Naples et l'expérience a été tout simplement excellente. Dès le premier instant on perçoit un accueil authentique, chaleureux et professionnel."
  },
  {
    id: "g2",
    source: "google",
    score: 5,
    author: "Ada Cristillo",
    country: "Italia",
    date: "2025-07",
    lang: "it",
    text_it: "Tre notti meravigliose. Struttura curata e pulitissima, accoglienza eccezionale. Sono stata colpita dal tema 'I Maestri': Dante alla reception, le sette regole di Paracelso in stanza. Un viaggio dell'anima che si amalgama con la Napoli esoterica delle leggende. Lo consiglio a chi vuole contattare il Maestro in se stesso.",
    text_en: "Three wonderful nights. A well-kept, spotless property with exceptional hospitality. I was struck by the 'I Maestri' theme: Dante at the reception, the seven rules of Paracelsus in the room. A journey of the soul that blends with the esoteric Naples of legends. Recommended to anyone wishing to meet the Master within themselves.",
    text_fr: "Trois nuits merveilleuses. Établissement soigné et impeccable, accueil exceptionnel. J'ai été frappée par le thème 'I Maestri' : Dante à la réception, les sept règles de Paracelse dans la chambre. Un voyage de l'âme qui se mêle à la Naples ésotérique des légendes. À recommander à qui souhaite rencontrer le Maître en soi."
  },
  {
    id: "g3",
    source: "google",
    score: 5,
    author: "Vittoria Crescini",
    country: "Italia",
    date: "2025-07",
    lang: "it",
    text_it: "Consigliatissimo! Posizione ottima, nella centralissima Via dei Tribunali. Valeria è una persona squisita, di una gentilezza e disponibilità unica. È la sesta volta che torno qui, impensabile per me cambiare struttura. Grazie di cuore.",
    text_en: "Highly recommended! Great location, in the heart of Via dei Tribunali. Valeria is a wonderful person — uniquely kind and helpful. This is my sixth time back; I couldn't imagine choosing anywhere else. Thank you from the bottom of my heart.",
    text_fr: "Hautement recommandé ! Emplacement idéal, en plein cœur de Via dei Tribunali. Valeria est une personne adorable, d'une gentillesse et d'une disponibilité uniques. C'est la sixième fois que je reviens, impensable de changer d'adresse. Merci du fond du cœur."
  },
  {
    id: "g4",
    source: "google",
    score: 5,
    author: "Alex Cav",
    country: "Italia",
    date: "2025-07",
    lang: "it",
    text_it: "Quattro giorni indimenticabili in questo bellissimo B&B a Napoli. Vincenzo ci ha accolti con grande gentilezza, facendoci sentire come a casa. Struttura curata nei minimi dettagli, colazione abbondante con prodotti freschi. Un B&B boutique da 5 stelle.",
    text_en: "Four unforgettable days in this beautiful B&B in Naples. Vincenzo welcomed us with great kindness and made us feel at home. The property is taken care of in every detail, with a generous breakfast and fresh local produce. A boutique 5-star B&B.",
    text_fr: "Quatre jours inoubliables dans ce magnifique B&B à Naples. Vincenzo nous a accueillis avec une grande gentillesse et nous a fait nous sentir chez nous. Établissement soigné dans les moindres détails, petit-déjeuner copieux avec des produits frais. Un B&B boutique 5 étoiles."
  },
  {
    id: "g5",
    source: "google",
    score: 5,
    author: "Cristina",
    country: "Italia",
    date: "2025-07",
    lang: "it",
    text_it: "Abbiamo trascorso 2 notti in questo b&b nel centro di Napoli, la posizione è perfetta per vivere e visitare la città. Le camere sono spaziose, accoglienti e pulitissime. Valeria è stata molto gentile, torneremo sicuramente.",
    text_en: "We spent 2 nights at this b&b in the heart of Naples — the location is perfect to live and discover the city. The rooms are spacious, welcoming and spotlessly clean. Valeria was so kind; we will definitely come back.",
    text_fr: "Nous avons passé 2 nuits dans ce b&b au cœur de Naples, l'emplacement est parfait pour vivre et visiter la ville. Les chambres sont spacieuses, accueillantes et impeccablement propres. Valeria a été très gentille, nous reviendrons sans aucun doute."
  },
  {
    id: "g6",
    source: "google",
    score: 5,
    author: "Mirko Lorenzini",
    country: "Italia",
    date: "2025-07",
    lang: "it",
    text_it: "Siamo stati due notti in questo inaspettato B&B. Nel pieno cuore di Napoli, un alloggio pulito e tranquillo con un'accoglienza calorosa. Grazie a Valeria per averci permesso di scoprire Napoli e i suoi segreti in completa tranquillità. Ritorneremo.",
    text_en: "We spent two nights in this unexpected B&B. In the very heart of Naples, a clean and peaceful stay with a truly warm welcome. Thank you Valeria for letting us discover Naples and its secrets in complete calm. We will return.",
    text_fr: "Nous avons passé deux nuits dans ce B&B inattendu. En plein cœur de Naples, un hébergement propre et tranquille avec un accueil chaleureux. Merci à Valeria de nous avoir permis de découvrir Naples et ses secrets en toute tranquillité. Nous reviendrons."
  }
];

// Aggregated public review pages (for "view all" links)
export const REVIEW_LINKS = {
  booking: "https://www.booking.com/hotel/it/beb-i-maestri.it.html?label=gen173bo-10CAsocUINYmViLWktbWFlc3RyaUgzWANocYgBAZgBM7gBF8gBDNgBA-gBAfgBAYgCAZgCBqgCAbgCjOnf0QbAAgHSAiQxOGU4YjhiNy1iNjM3LTRlMjktODdlMC00YjAwMGQ2YmY3NDDYAgHgAgE&sid=350cd785f725fc918c3764df85371eb6&dist=0#tab-reviews",
  airbnb: "https://www.airbnb.com/rooms/1252562202537727965/reviews",
  google: "https://www.google.com/search?q=B%26B+I+Maestri+Napoli+recensioni",
  tripadvisor: "https://www.tripadvisor.it/Hotel_Review-g187785-B%26B_I_Maestri-Naples_Province_of_Naples_Campania.html"
};
